import { format } from 'date-fns';
import { TZDate } from '@date-fns/tz';

/**
 * Normalizes a filename to match the required format:
 * - Replaces spaces with underscores
 * - Converts to lowercase
 * - Removes invalid characters
 * - Provides a fallback filename if everything was an invalid char
 *
 * No validation is performed on this function
 *
 * @param filename The original filename
 * @returns Normalized filename
 */
export const normalizeFilename = (filename: string): string => {
  const lastDotIndex = filename.lastIndexOf('.');
  const baseName =
    lastDotIndex !== -1 ? filename.substring(0, lastDotIndex) : filename;
  const extension =
    lastDotIndex !== -1
      ? filename.substring(lastDotIndex + 1).toLowerCase()
      : '';

  const normalizedBaseName = baseName
    .replace(/\s+/g, '_') // Replace spaces with underscores
    .toLowerCase() // Convert to lowercase
    .replace(/[^a-z0-9-_]/g, ''); // Remove anything that's not lowercase letter, number, hyphen or underscore

  // Ensure we have a valid base name (if all chars were stripped)
  const uniqueSuffix = format(TZDate.tz('UTC'), 'yyyyMMdd_HHmmss_SSS');
  const finalBaseName = normalizedBaseName || `file_${uniqueSuffix}`;

  return `${finalBaseName}.${extension}`;
};
